// extracted by mini-css-extract-plugin
module.exports = {"experiences":"AboutExperiences-module--experiences--29tDp"};